(() => {
  'use strict';
  const feeHandles = new Set(['9-99', '9-99-center-chest', '14-99-all-over']);
  const root = window.Shopify?.routes?.root || '/';
  let timer, busy = false, again = false;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(reconcile, 650); };
  async function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart.items?.length || cart.items.some(item => !feeHandles.has(item.handle))) return;
      const updates = Object.fromEntries(cart.items.map(item => [item.key, 0]));
      const result = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({updates})
      });
      if (!result.ok) return;
      const updated = await result.json();
      if (!updated.errors) window.location.reload();
    } catch (error) {
      console.warn('Printing fee cleanup could not complete.', error);
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }
  const cartRoot = document.querySelector('#MainContent');
  if (cartRoot) new MutationObserver(schedule).observe(cartRoot, {childList: true, subtree: true});
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  document.addEventListener('click', event => {
    if (event.target.closest('cart-remove-button, .quantity__button')) schedule();
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('input[name="updates[]"]')) schedule();
  }, true);
  schedule();
})();
